'use strict';

var _ = require('lodash');
var FilterBySposFactory = function FilterBySposFactory(DataFilter) {
  function FilterBySpos() {
    DataFilter.call(this, 'fares-mode', 'fbcs-grid', 1);
  }
  FilterBySpos.prototype = Object.create(DataFilter.prototype);
  FilterBySpos.prototype.filter = function (data, range) {
    range = range[0];
    var classSposes = range.classSposes;
    _.forEach(data, function (element) {
      var classValue = !_.isNil(element.className) ? element.className : element.bookingClass;
      element.classNameSpos = classValue + '_' + element.spos;
    });
    return DataFilter.prototype.filter(data, classSposes, 'classNameSpos');
  };
  return FilterBySpos;
};
FilterBySposFactory.$inject = ['DataFilterFactory'];
module.exports = FilterBySposFactory;